"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M18 3.5a.5.5 0 0 0-1 0v1.691c-1.143-.988-2.69-1.504-4.167-1.65a8.5 8.5 0 1 0 7.667 8.46.5.5 0 0 0-1 0 7.5 7.5 0 1 1-6.765-7.465c1.38.136 2.726.62 3.67 1.464H14.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.5 8a.5.5 0 0 0-1 0v3.586a.5.5 0 0 1-.146.353l-2.208 2.207a.5.5 0 0 0 .708.708l2.207-2.208a1.5 1.5 0 0 0 .439-1.06z"
  })]
}), 'Delay');
